var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"error",attrs:{"sub-title":_vm.$t('errorView.cantFindPage'),"title":"404","icon":"exclamation-triangle"}},[_c('p',[_vm._v(_vm._s(_vm.$t('not')))])])}
var staticRenderFns = []

export { render, staticRenderFns }